import { create } from 'zustand';

const useProductStore = create((set) => ({
  productStockPriceData: {
    isFetched: false,
    productRecord: {
      productPriceList: null,
      productPriceDiscountList: null,
      stockNumber: 0,
    },
    gdWarehouseStockNumber: 0,
    jsWarehouseStockNumber: 0,
    smtStockNumber: 0,
  },
  // 流控状态
  flowControlState: {
    rateLimitInfo: null,
  },
  updateProductStockPriceData: (productStockPriceData) => set({ productStockPriceData }),
  updateFlowControlState: (flowControlState) =>
    set((state) => ({
      flowControlState: { ...state.flowControlState, ...flowControlState },
    })),
}));

export default useProductStore;
